import script from "./navpicker.vue?vue&type=script&setup=true&lang=js"
export * from "./navpicker.vue?vue&type=script&setup=true&lang=js"

import "./navpicker.vue?vue&type=style&index=0&id=1913fb15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1913fb15"]])

export default __exports__